var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex", attrs: { id: "billing-base" } }, [
    _c("div", { staticClass: "flex flex-col flex-grow" }, [
      _c(
        "div",
        {
          staticClass:
            "sticky top-18 left-0 z-50 h-18 px-6 flex items-center flex-shrink-0 bg-pure-white",
          style: { width: "calc(100vw - 0.5rem)" },
          attrs: { id: "billing-header" }
        },
        [
          _c(
            "div",
            { staticClass: "flex items-center gap-2" },
            [_c("BlTextTitle3", { attrs: { text: "Billing" } })],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.pageLoading
        ? _c("div", { staticClass: "w-full h-128 grid place-items-center" }, [
            _c("div", { staticClass: "blum-loader" })
          ])
        : _c("div", { staticClass: "flex flex-col flex-grow" }, [
            _c(
              "div",
              {
                staticClass:
                  "sticky top-36 left-0 z-50 pb-4 px-6 flex gap-4 flex-shrink-0 bg-pure-white",
                style: { width: "calc(100vw - 0.5rem)" },
                attrs: { id: "billing-details" }
              },
              [
                _c(
                  "div",
                  { staticClass: "w-full flex flex-col gap-1" },
                  [
                    _c("BlTextBody2", {
                      staticClass: "text-light-purple-400",
                      attrs: { text: "Your team plan:" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "font-bold text-dark-purple-100",
                        style: { fontSize: "1.375rem" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.currentSubscription
                                ? _vm.subscriptionTypes[
                                    _vm.currentSubscription.type
                                  ]
                                : "-"
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "h-full w-0.5 flex-shrink-0",
                  style: {
                    background:
                      "linear-gradient(180deg, #FFFFFF 0%, #E6DBF3 50%, #FFFFFF 100%)"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-full flex flex-col gap-1" },
                  [
                    _c("BlTextBody2", {
                      staticClass: "text-light-purple-400",
                      attrs: { text: "Next billing date:" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "font-bold text-dark-purple-100",
                        style: { fontSize: "1.375rem" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.displayDate({
                                date:
                                  _vm.currentSubscription &&
                                  _vm.currentSubscription.next_billing_date,
                                format: "DD MMMM YYYY"
                              })
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "h-full w-0.5 flex-shrink-0",
                  style: {
                    background:
                      "linear-gradient(180deg, #FFFFFF 0%, #E6DBF3 50%, #FFFFFF 100%)"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-full flex flex-col gap-1" },
                  [
                    _c("BlTextBody2", {
                      staticClass: "text-light-purple-400",
                      attrs: { text: "Estimated annual bill:" }
                    }),
                    _vm._v(" "),
                    !_vm.currentSubscription
                      ? _c("div", { staticClass: "flex gap-1" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "font-bold text-dark-purple-100 text",
                              style: { fontSize: "1.375rem" }
                            },
                            [_vm._v("\n              -\n            ")]
                          )
                        ])
                      : _c(
                          "div",
                          { staticClass: "flex gap-1" },
                          [
                            _c("BlTextSubtitle2", {
                              staticClass: "text-light-purple-200",
                              attrs: {
                                text: _vm.currentSubscription.currency_sym
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "font-bold text-dark-purple-100 text",
                                style: { fontSize: "1.375rem" }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.priceFormats(
                                        _vm.currentSubscription.amount
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "h-full w-0.5 flex-shrink-0",
                  style: {
                    background:
                      "linear-gradient(180deg, #FFFFFF 0%, #E6DBF3 50%, #FFFFFF 100%)"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-full flex flex-col gap-1" },
                  [
                    _c("BlTextBody2", {
                      staticClass: "text-light-purple-400",
                      attrs: { text: "Number of team members:" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "font-bold text-dark-purple-100 text",
                        style: { fontSize: "1.375rem" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.currentCenter.total_active_members) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      { attrs: { to: "/team" } },
                      [
                        _c("BlInputButton", {
                          staticClass: "w-full",
                          attrs: {
                            type: "outlined",
                            dense: "",
                            label: "Manage team"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "h-100 w-full grid place-items-center text-center",
                attrs: { id: "billing-body" }
              },
              [
                _c("BlTextBody2", {
                  attrs: {
                    text:
                      "Exciting updates ahead: Your billing history and invoices will appear here soon!"
                  }
                })
              ],
              1
            )
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c579532", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c579532","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/billing/Billing.vue
// module id = null
// module chunks = 